
export default
function TextBlock({ children }) {
	return (
		<p className="text-white bg-black" >{children}</p>
	)
}
